import BaseComponent from "../../baseComponent.js";
import IdentityAccessService from "../../../core/services/identityAccessService.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import styles from "./styles.scss";

export default class PasswordChange extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getInitialValues();
  }

  componentDidMount() {
    $(this.refs.container).find("select").material_select();
    this.state.User = IdentityAccessService.getUserProfile();
  }

  sendPasswordUpdateRequest() {
    let NPassword = this.state.NPassword;
    let CPassword = this.state.CPassword;

    if(this.state.RTPassword == this.state. NPassword && NPassword.length > 0 && CPassword.length > 0) {
      IdentityAccessService.updateUserCredential(this.state.CPassword, this.state.NPassword).then((status) => {
        this.publish(InternalEvent.App.SHOW_APP_MODAL, {type: "notify", header: status});
      });
      this.setState({
        CPassword: "",
        RTPassword: "",
        NPassword: ""
      });
    }
    else if(CPassword.length == 0){
      this.publish(InternalEvent.App.SHOW_APP_MODAL, {type: "notify", header: "Please enter current password!"});
    }
    else if(NPassword.length == 0){
      this.publish(InternalEvent.App.SHOW_APP_MODAL, {type: "notify", header: "New password is too short!"});
    }
    else{
      this.publish(InternalEvent.App.SHOW_APP_MODAL, {type: "notify", header: "Re-typed password does not match new password!"});
    }
  }

  updateStatus(status, textInfo) {
    var currentDate = new Date();
    if (status == "fail") {
      document.getElementById("status-check").innerHTML = '<div class="col s12"><div class="login-modal__error"> <i class="fa fa-exclamation-triangle"></i><span>' + textInfo
        + '</span><span>' + currentDate.toUTCString() + '</span></div></div>';
    }
    else {
      document.getElementById("status-check").innerHTML = '<div class="col s12"><div class="status__success"> <i class="fa fa-check-circle"></i><span>'
        + textInfo + '</span><span>' + currentDate.toUTCString() + '</span></div></div>';
    }
  }

  getInitialValues() {
    return {
      CPassword: "",
      NPassword: "",
      RTPassword: "",
      Error: "",
      User: null
    };
  }

  handleChange(field) {
    var _this = this;
    return function (event) {
      var state = {};
      state[field] = event.target.value;
      _this.setState(state);
    };
  }

  render() {
    return (
      <ul className="center-object" ref="container">
        <li>
          <div id="status-check"></div>
        </li>
        <li>
          <h1 className="user-profile-title-text">
            <div className="h1-title-spacing-s">Password Settings</div>
          </h1>
          <div className="layout-user-profile">
            <div className="box-1">
              <div className="space-box-150px-70px"></div>

            </div>
            <div className="box-2">
              <table>
                <tbody>
                <tr>
                  <td className="td-right-align"><div className="account-table-cell">Current Password:</div></td>
                  <td className="td-left-align"><div className="account-text-box">
                      <input type="password" value={this.state.CPassword} onChange={this.handleChange('CPassword')}/>
                      </div>
                  </td>
                </tr>
                <tr>
                  <td className="td-right-align"><div className="account-table-cell">New Password:</div></td>
                  <td className="td-left-align"><div className="account-text-box">
                      <input type="password" value={this.state.NPassword} onChange={this.handleChange("NPassword")}/>
                      </div>
                  </td>
                </tr>
                <tr><td className="td-right-align"><div className="account-table-cell">Re-typed Password:</div></td>
                  <td className="td-left-align"><div className="account-text-box">
                      <input type="password" value={this.state.RTPassword} onChange={this.handleChange("RTPassword")}/>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="box-3">
              <div className="space-box-150px-70px"></div>
            </div>
          </div>
        </li>
        <li>
          <div className="layout-user-profile">
            <div className="box-1">
              <div className="space-box-150px-70px"></div>
            </div>
            <div className="box-2">
              <table>
                <tbody>
                <tr>
                  <td className="td-right-alignS">
                  </td>
                  <td className="td-left-align">
                    <div className="account-table-cell">
                      <a className="waves-effect waves-light btn" onClick={this.sendPasswordUpdateRequest}>Update</a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="box-3">
              <div className="space-box-150px-70px"></div>
            </div>
          </div>
        </li>
      </ul>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/account/passwordChange.jsx